const arrayToMap = (array, key) => (
    array.reduce(
        (map, item) => {
            map[item[key]] = item;

            return map;
        },
        {}
    )
);

export default arrayToMap;
